import { SchedulesContainerObjectType } from '@/interfaces/schedulesContainerObjectType';
import { EntityResource } from './entity.resource';

/**
 * Resource harmonogramów
 *
 * @export
 * @class ScheduleResource
 * @extends {EntityResource<SchedulesContainerObjectType>}
 */
export class ScheduleResource extends EntityResource<SchedulesContainerObjectType> {
  public getFields = {
    id: true,
    name: true,
    description: true,
    start: true,
    end: true,
    entityType: true,
    entityId: true,
    schedules: {
      name: true,
      description: true,
      start: true,
      end: true,
      type: true,
      frequencyType: true,
      frequency: true,
      day: true,
      month: true,
      week: true,
      hour: true,
      minute: true,
      order: true,
      duration: true
    }
  };

  public listFields = {
    id: true,
    name: true,
    description: true,
    start: true,
    end: true
  };
  protected listVariables = { filters: 'SchedulesContainerFilters' };

  constructor() {
    super({ entityName: 'schedulesContainer' });
  }
}

export const scheduleResource = new ScheduleResource();
